<template>
    <div class="question-list-page">
        <question-trees @selectClick="selectHandle"></question-trees>
        <div class="question-table scroll-tracker">
            <div class="content-top">
                <p>
                    <span class="tit">{{ currentScene }}</span
                    >（{{ $t("zhiji.common.total") }} <em>{{ standTotal }}</em> {{ $t("zhiji.knowlege.standQustUnit") }}，<em>{{ extandTotal }}</em>
                    {{ $t("zhiji.knowlege.similarQustUnit") }}，<em>{{ answerTotal }}</em> {{ $t("zhiji.knowlege.answerUnit") }}）
                </p>
                <OperationBar class="content-opeat" @initCurrPage="initCurrPage" :standTotal="standTotal" />
            </div>
            <Table
                :curPage="curPage"
                :config="tableConfig"
                :dataset="tableData"
                :total="standTotal"
                @columnClick="tableColumnClick"
                @bottomBtnClick="bottomBtnClick"
                @pageChange="pageChange"
            />
        </div>
    </div>
</template>

<script>
import Table from "@/views/zhiji/bComponents/table/Table";
import QuestionTrees from "./components/QuestionTrees";
import OperationBar from "./components/OperationBar";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";

import { recursionTrans, recursionFind } from "@/views/zhiji/js/common/util.js";
import { quesListTable } from "./pageConfig.js";
import i18n from "@/i18n";

export default {
    name: "QuestionDetail",
    components: {
        Table,
        OperationBar,
        QuestionTrees
    },
    data() {
        return {
            curPage: 1,
            curPageLen: quesListTable().pageLength
        };
    },
    computed: {
        tableData() {
            return this.getStorePorp("tableDatas");
        },
        standTotal() {
            return this.getStorePorp("standTotal");
        },
        extandTotal() {
            return this.getStorePorp("extandTotal");
        },
        answerTotal() {
            return this.getStorePorp("answerTotal");
        },
        classMenu() {
            let treeData = this.getStorePorp("treeData").children || [];
            return recursionTrans(
                treeData,
                function(treesData) {
                    return {
                        value: treesData.id,
                        label: treesData.label
                    };
                },
                "children"
            );
        },
        currentScene() {
            let selectedSceneId = this.getStorePorp("querySetting").classId;

            return selectedSceneId ? this.getSceneNameById(selectedSceneId) : i18n.t("zhiji.common.allClassify");
        },
        tableConfig() {
            return this.getTableConfig();
        }
    },
    mounted() {
        this.$store.commit("zhiji/initQuerySetting");
        let reqParam = {
            page: this.curPage,
            size: this.curPageLen,
            classId: ""
        };
        this.getQuestionList(reqParam);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        getQuestionList(reqParam) {
            this.$store.dispatch("zhiji/queryQuestionList", reqParam);
            this.$store.dispatch("zhiji/queryExtQuestionTotal", reqParam);
            this.$store.dispatch("zhiji/queryAnswersTotal", reqParam);
        },
        initCurrPage() {
            this.curPage = 1;
        },
        getTableConfig() {
            let newTableData = quesListTable();
            newTableData.bottomButtons.some(button => {
                if (button.id === "transfer") {
                    button.getOptions = () => this.classMenu;
                    return true;
                }
            });
            return newTableData;
        },
        tableColumnClick(data) {
            // 标准问题点击
            if (data.colId === "standQuestion") {
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.rowId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "AnswerPanel",
                        hasRecommendSimilar: data.rowData.addData.recommendSimilar,
                        closeHandler: () => {
                            this.getQuestionList({
                                page: this.curPage
                            });
                        }
                    }
                });
            } else if (data.colId === "similarQuestion") {
                // 相似问题点击
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.rowId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "SimilarPanel",
                        currentTab: "ExistingSimilars",
                        hasRecommendSimilar: data.rowData.addData.recommendSimilar,
                        closeHandler: () => {
                            this.getQuestionList({
                                page: this.curPage
                            });
                        }
                    }
                });
            }
        },
        bottomBtnClick(buttonId, selectedRowIds, option) {
            this.bottomClickAction(selectedRowIds, buttonId, option);
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getQuestionList({
                page: data.curPage,
                size: data.pageLength
            });
        },
        // table底部按钮操作总入口
        bottomClickAction(editData, data, option) {
            const handlers = {
                delete: this.deleteAction,
                online: this.onlineAction,
                offline: this.offlineAction,
                transfer: this.transferAction,
                export: this.exportAction
            };

            handlers[data].call(null, editData, option);
        },
        onlineAction(selectedRowIds) {
            if (!selectedRowIds.length) {
                this.messageTip(i18n.t("zhiji.knowlege.selectQuesLabel"));
                return;
            }
            const questionId = this.getQuestionId(selectedRowIds);
            if (questionId.length > 0) {
                this.effectQuestion(questionId.join(","), i18n.t("zhiji.knowlege.onlineRelatedTip"), () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: "online",
                        questionId: [...selectedRowIds]
                    });
                });
            } else {
                this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                    status: "online",
                    questionId: [...selectedRowIds]
                });
            }
        },
        offlineAction(selectedRowIds) {
            if (!selectedRowIds.length) {
                this.messageTip(i18n.t("zhiji.knowlege.selectQuesLabel"));
                return;
            }
            const questionId = this.getQuestionId(selectedRowIds);
            if (questionId.length > 0) {
                this.effectQuestion(questionId.join(","), i18n.t("zhiji.knowlege.offlineRelatedTip"), () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: "offline",
                        questionId: [...selectedRowIds]
                    });
                });
            } else {
                let configText = selectedRowIds.length > 1 ? i18n.t("zhiji.knowlege.offlineQuesTip2") : i18n.t("zhiji.knowlege.offlineQuesTip1");
                this.messageTip(configText, () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: "offline",
                        questionId: [...selectedRowIds]
                    });
                });
            }
        },
        transferAction(selectedRowIds, option) {
            if (selectedRowIds.length > 0) {
                this.$store.dispatch("zhiji/transferQuestions", {
                    classId: option.value,
                    questionId: [...selectedRowIds]
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("zhiji.knowlege.selectQuesLabel")
                    }
                });
            }
        },
        deleteAction(selectedRowIds) {
            if (!selectedRowIds.length) {
                this.messageTip(i18n.t("zhiji.knowlege.selectQuesLabel"));
                return;
            }
            const questionId = this.getQuestionId(selectedRowIds);
            if (questionId.length > 0) {
                this.effectQuestion(questionId.join(","), i18n.t("zhiji.knowlege.deleteRelatedTip"), () => {
                    this.$store.dispatch("zhiji/deleteQuestions", {
                        questionId: [...selectedRowIds]
                    });
                });
            } else {
                let configText = selectedRowIds.length > 1 ? i18n.t("zhiji.knowlege.deleteQuesTip2") : i18n.t("zhiji.knowlege.deleteQuesTip1");
                this.messageTip(configText, () => {
                    this.$store.dispatch("zhiji/deleteQuestions", {
                        questionId: [...selectedRowIds]
                    });
                });
            }
        },
        exportAction(selectedRowIds) {
            if (selectedRowIds.length > 0) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "ExportFaqModal",
                    data: {
                        type: "question_ids",
                        rowIds: selectedRowIds
                    }
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("zhiji.knowlege.exportModal.notSelected")
                    }
                });
            }
        },
        getSceneNameById(sceneId) {
            const treeData = this.getStorePorp("treeData").children || [];

            let scene = recursionFind(
                treeData,
                nodeData => {
                    return nodeData.id == sceneId;
                },
                "children"
            );

            return scene ? scene.label : "";
        },
        selectHandle() {
            this.initCurrPage();
        },
        messageTip(tipTxt, callBack = () => {}) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipTxt,
                    cancel: () => {},
                    confirm: () => {
                        callBack();
                    }
                }
            });
        },
        // 获取为默认语种的标问id
        getQuestionId(selectedRowIds) {
            const treeData = this.getStorePorp("tableDatas") || [];
            // 获取当前的默认语种
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang || "en";
            return selectedRowIds.filter(item => {
                return treeData.some(child => item === child.rowId && child.addData.langType === defaultLang);
            });
        },
        // 提示被影响的相关标问
        effectQuestion(questionId, tipTxt, callBack) {
            this.zhiji
                .requestByServiceName("getRelatedQuestion", {
                    questionId
                })
                .then(resp => {
                    let tipStr = tipTxt;
                    resp.map(item => {
                        tipStr += `\n ${item.question}(${i18n.t("zhiji.knowlege.questionName")})， question_id=${item.questionId}`;
                    });
                    resp.length &&
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "tip",
                                message: tipStr,
                                cancel: () => {},
                                confirm: () => {
                                    callBack();
                                }
                            }
                        });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.question-list-page {
    height: 100%;
    display: flex;
    box-sizing: border-box;

    .question-table {
        display: flex;
        flex: 1;
        flex-direction: column;
        overflow: auto;

        .content-top {
            position: relative;
            padding: 15px 16px 0 24px;
            box-sizing: border-box;
            > p {
                margin-top: 10px;
            }
            em {
                color: #00c972;
            }
            .tit {
                font-size: 14px;
            }
            .content-opeat {
                margin-top: 20px;
            }
            .opeat-l,
            .select-opt,
            .opeat-r {
                display: inline-block;
            }
            .opeat-l {
                margin-top: 4px;
            }
            .opeat-l,
            .opeat-r {
                font-size: 0;
            }
        }
    }
    .table-wrapper {
        flex: 1;
    }
}
</style>
